export default __webpack_public_path__ + "static/media/infant-patient-room-2.74fc3afd.jpg";